module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create_new_note":"Create new note","use_feature_to_collect":"Use this feature to collect more information","from_customers_about":"from customers about a product"},"id":{"create_new_note":"Buat nota baharu","use_feature_to_collect":"Gunakan fungsi ini untuk mendapatkan lebih info","from_customers_about":"dari pelanggan tentang produk"}}')
  delete Component.options._Ctor
}
